import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "CashPointClosingReport";

const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-3">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.beginDate.name}
                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                        fullWidth={true}
                        required
                    />
                </div>
                <div className="col-xs-12 col-sm-6 col-md-3">
                    <DatePickerInput
                        name={componentName + LOOKUP.report.common.endDate.name}
                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                        hintText={LOOKUP.report.common.endDate.label + "*"}
                        fullWidth={true}
                    />
                </div>
                <div className="col-xs-12 col-sm-6">
                    {<BranchSelectAutoCompleteInput
                                    name={componentName + LOOKUP.report.common.branchName}
                                    label={LOOKUP.report.common.branch + "*"}
                                />}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <Button
                        type="DownloadButton"
                        className="pull-right mt-2 btnNewBrandPOS"
                        name={componentName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={props.download}
                    />
                </div>
            </div>
            <br />
            {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className="purpleText"><b>Note: </b><strong className="blue-text"><i></i></strong></p>
            </div> */}
        </div>
    </CardSimple>
);

export default Header;
